export default "__VITE_ASSET__BhwlS3Lx__"